import { FunctionComponent, SyntheticEvent, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { AuthService } from "../../services/auth";
import { useAsync } from "../../utils/hooks/useAsync";
import "../ForgotPasswordContainer/styles.scss";
import { CompleteRestoreForm } from "./RestorePasswordForm";
import Label from "../Label";

const initialCodeState = {
  0: "",
  1: "",
  2: "",
  3: "",
  4: "",
  5: "",
};

const CompletePasswordContainer: FunctionComponent = ({}) => {
  const { email } = useContext(UserContext).user;
  const [code, setCode] = useState<{ [key: string]: string }>(initialCodeState);
  const [password, setPassword] = useState("");
  const { run, isLoading } = useAsync();
  const navigate = useNavigate();
  const handleUpdateCode = (ix: string, e: any) => {
    e.preventDefault();
    if (isNaN(e.key) && e.key !== "Backspace" && e.key !== "Delete") {
      return false;
    }
    const updatedCode = JSON.parse(JSON.stringify(code));
    if (e.key === "Backspace" || e.key === "Delete") {
      updatedCode[ix] = "";
      setCode(updatedCode);
    } else {
      updatedCode[ix] = e.key || "";
      setCode(updatedCode);
      const nextElementId = `code-${Number(ix) + 1}`;
      setTimeout(() => document?.getElementById(nextElementId)?.focus(), 50);
    }
    return false;
  };

  const validateCode = (code: string) => {
    if (code.length === 6) return true;
    return false;
  };

  const handleSubmit = (e: SyntheticEvent, code: {}, newPassword: string) => {
    e.preventDefault();
    const parsedCode = Object.values(code).join("");
    const isCodeValid = validateCode(parsedCode);
    if (!isCodeValid) {
      throw new Error("Invalid code");
    }
    run(AuthService.CompletePasswordChange(email, parsedCode, newPassword))
      .then((data) => {
        navigate("/login");
      })
      .catch((err) => {
        throw new Error(err);
      });
  };

  return (
    <section className="forgot-password">
      <header>
        <Label tag="h1" className="forgot-password__title">
          Ingresá contraseña
        </Label>
      </header>
      <CompleteRestoreForm
        handleSubmit={handleSubmit}
        handleUpdateCode={handleUpdateCode}
        code={code}
        password={password}
        setPassword={setPassword}
        isLoading={isLoading}
      />
    </section>
  );
};

export default CompletePasswordContainer;
